import { render, staticRenderFns } from "./DefaultTpl.vue?vue&type=template&id=b523b106&scoped=true"
import script from "./DefaultTpl.vue?vue&type=script&lang=js"
export * from "./DefaultTpl.vue?vue&type=script&lang=js"
import style0 from "./DefaultTpl.vue?vue&type=style&index=0&id=b523b106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b523b106",
  null
  
)

export default component.exports